import React from 'react';
import { useLocation } from 'react-router-dom';
import HeaderLoged from '../Components/HeaderLoged/HeaderLoged';
import Header from '../Components/Header/Header';
import HeaderTeacher from '../Components/HeaderTeacher/HeaderTeacher';

const DynamicHeader = ({ isLoggedIn, setLoggedIn, profileImage, setProfileImage }) => {   
  const location = useLocation();

  if (location.pathname.startsWith('/teacher-', '/admin-page/*')) {
    return <HeaderTeacher setLoggedIn={setLoggedIn}/>;
  }

  return isLoggedIn ? <HeaderLoged 
                        setLoggedIn={setLoggedIn} 
                        profileImage={profileImage} 
                        setProfileImage={setProfileImage}/> 
                        
                      : <Header />;
};

export default DynamicHeader;
